module.exports = __webpack_public_path__ + "static/media/timer-displayed-screen.2f5a6b2f.png";